import {apiGet, apiInstance} from "@/services/api";
import {Currency, Excursion, ExcursionResponse} from "@/services/excursions/types";

function exchangeCurrency(excursion: Excursion){
    const rubExchangeRate: Record<Currency, number> = {
        "EUR": 87,
        "RUB": 1,
        "USD": 78.61
    }

    const price = excursion.price;
    const rate = rubExchangeRate[excursion.currency];

    if(rate && price){
        excursion.price = Math.floor(price * rate);
    }

    return excursion;
}

export async function index(city_code: string): Promise<ExcursionResponse>{
    const excursions: ExcursionResponse = await apiGet("/excursions/",{city_code});
    excursions.DATA = excursions.DATA.map(excursion=>exchangeCurrency(excursion));
    return excursions;
}